import React, { useEffect } from "react";
import "../Style/Contact.css";
import { FaLocationDot } from "react-icons/fa6";
import { MdCall } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import sec6 from "../Assets/sec6.png";
import c1 from "../Assets/c1.png";
import { useAppointment } from "./AppointmentContext.js";
import BookAppointment from "./BookAppointment.js";
import { useAuth } from "./UserContext.js";

const ContactUs = () => {
  const { makeCall } = useAuth();
  const { appointmentData, handleAppointment } = useAppointment();
  const isMobile = window.innerWidth <= 768;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="contact-container">
      <h1 className="contact-h1">Contact Us</h1>
      <p className="contact-para">
        Thank you for visiting our website! Whether you're seeking more
        information on homeopathy, looking to book a consultation, or simply
        have a question, we're here to help. Our team of experienced
        professionals is dedicated to supporting your health and well-being with
        natural, holistic remedies.
      </p>
      <h1 className="contact-h2">How Can We Assist You?</h1>
      <p className="contact-para">
        We are happy to answer any questions or concerns you may have about
        homeopathy or our services. Please don't hesitate to reach out through
        any of the following options:
      </p>
      <div className="contact-sec-1">
        <div className="contact-sec-1-1">
          <h1>Get in touch :</h1>
          <p className="contact-sec-1-1-p1">
            Due our contact form for all information requests or contact us
            rectly using the contact information below
          </p>
          <p className="contact-sec-1-1-p1">
            Feel free to get in touch with us via email or phone
          </p>
          <div className="contact-border-line"></div>
          <div className="contact-sec-1-2">
            <FaLocationDot size={35} color="var(--primary-color)" />
            <div>
              <h1 className="contact-sec-1-h2">Our Clinic Location</h1>
              <p className="contact-sec-1-1-p1" style={{ marginTop: "8px" }}>
                in front of Bank of Baroda Service Center, Didarganj Road, Kheta
                sarai-Jaunpur, Uttar Pradesh 222139
              </p>
              <p className="contact-sec-1-1-p1">
                in front of Line bajar Police station Matapur, Line Bajar,
                Jaunpur Uttar Pradesh 222002
              </p>
              <p className="contact-sec-1-1-p1">
                Near Baroda UP Bank Gauspur Khutahan Main Road Jaunpur
                Uttar Pradesh 223104
              </p>
            </div>
          </div>
          <div
            className="contact-sec-1-3"
            onClick={makeCall}
            style={{ cursor: "pointer" }}
          >
            <MdCall size={35} color="var(--primary-color)" />
            <b style={{ fontSize: "20px", fontWeightL: "600" }}>
              Call:{" "}
              <span style={{ color: "var(--primary-color)" }}>9129371733</span>
            </b>
          </div>
        </div>
        <div className="contact-sec-1-2-1">
          <h1>Get started with a free quotation :</h1>
          <div className="contact-sec-input">
            <label>Name</label>
            <input placeholder="Enter Your Name" />
          </div>
          <div className="contact-sec-input">
            <label>Email</label>
            <input placeholder="Enter Your Email" />
          </div>
          <div className="contact-sec-input">
            <label>Message(Optional)</label>
            <input placeholder="Enter Message" />
          </div>
          <div className="contact-sec-input-1">
            <input type="checkbox" />
            <p>I accept the terms and conditions.</p>
          </div>
          <button className="doctor-btn-book-2">Book An Appointment</button>
        </div>
      </div>

      <div className="content-sec-5">
        <div className="content-sec-5-1">
          <h1
            className="skin-head-1"
            style={{ fontSize: isMobile ? "27px" : "42px" }}
          >
            Welcome To HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER
          </h1>
          <p className="skin-head-para" style={{ marginTop: "0px" }}>
            Our team of highly trained professionals uses the latest healing
            technologies to restore you to pain-free health quickly and easily.
          </p>
          <div className="doctor-treatment-name">
            <div className="doctor-treatment-name-1">
              {/* <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">
                  C.C.H. (Child Health) Consultant Physician
                </p>
              </div> */}
              <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">Multi Specialty Clinic</p>
              </div>
              {/* <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">
                  B.H.M.S , D.N.Y.T, S.V.D. (Skin & Venereal)
                </p>
              </div> */}
              <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">24 Hours Medical Service</p>
              </div>
            </div>
            <div className="doctor-btn-book-div">
              <button className="doctor-btn-book-1" onClick={handleAppointment}>
                Book An Appointment
              </button>
            </div>
          </div>
        </div>
        <div className="content-sec-5-img">
          <img src={sec6} />
        </div>
      </div>

      <div className="contact-sec-header-image">
        <div className="contact-sec-header-image-sec">
          <img src={c1} />
        </div>
        <div className="contact-sec-header-image-content">
          <h1 className="c1-h1">Visit Our Clinic :</h1>
          <p className="c1-p1">
            Feel free to visit us in person for consultations, treatments, or to
            speak with our specialists.{" "}
          </p>
          <p className="c1-p2">We are located at:</p>
          <p>
            in front of Bank of Baroda Service Center, Didarganj Road, Kheta
            sarai-Jaunpur, Uttar Pradesh 222139
          </p>

          <p className="c1-p2">Clinic Hours:</p>
          <p className="c1-p1">
            Monday and Thursday - 9:00 am to 1:00 pm, 3:00 pm to 7:00 pm
          </p>
          <p className="c1-p1">Sunday and Wednesday - 5:00 PM to 8:00 PM</p>
          <p className="c1-p1">
            Tuesday and Saturday - 9:00 a.m. to 1:00 p.m., 3:00 p.m. to 7:00
            p.m.
          </p>
        </div>
      </div>
      <div className="contact-last-sec">
        <h1 className="c1-h1-1">Book an Online Consultation</h1>
        <p className="c1-p1-1">
          We understand that your schedule may be busy, which is why we offer
          online consultations! No matter where you are, you can receive
          personalized homeopathic guidance. Simply click below to book an
          appointment at a time that works for you:
        </p>
        <h1 className="c1-p2-h1">Book an Online Consultation</h1>
        <div
          className="contact-sec-1-3"
          onClick={makeCall}
          style={{ cursor: "pointer" }}
        >
          <MdCall size={35} color="var(--primary-color)" />
          <b style={{ fontSize: "20px", fontWeightL: "600" }}>
            Call:{" "}
            <span style={{ color: "var(--primary-color)" }}>9129371733</span>
          </b>
        </div>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default ContactUs;
